// 契約選択画面（portal.md「契約選択画面」）。
// 所属が 1 つ（system-admin でない）なら選ばせずに TOP へ。複数か system-admin なら毎回選ぶ。
// active でない所属（無効化・受諾前）の契約は出さない。
// system-admin にはヘッダに「契約を作成」「システム設定」のタブを出す。
// 招待のリンクからのログインで来たときは、参加した契約を示す（Callback が state で渡す）。

import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { api, messageFor, type Me } from "../lib/api";
import { currentUser, signIn, signOut } from "../lib/auth";
import { landingPath, selectableMemberships } from "../lib/landing";
import { SystemHeader } from "./Header";

export function SelectContractPage() {
  const nav = useNavigate();
  const joined = (useLocation().state as { joined?: string } | null)?.joined;
  const [me, setMe] = useState<Me | null>(null);
  const [allContracts, setAllContracts] = useState<{ contractId: string; name: string }[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      if (!(await currentUser())) { await signIn(); return; }
      try {
        const m = await api.me();
        const sysadmin = m.platformRole === "system-admin";
        const landing = landingPath(m);
        if (landing !== "/select") { nav(landing, { replace: true }); return; }
        setMe(m);
        if (sysadmin) setAllContracts((await api.adminContracts()).contracts);
      } catch (e) {
        setError(messageFor(e));
      }
    })();
  }, [nav]);

  if (error) return <main className="narrow"><h1>ログイン</h1><p className="error">{error}</p><p><button onClick={signOut}>ログアウト</button></p></main>;
  if (!me) return <main className="narrow"><p className="muted">読み込み中…</p></main>;

  const memberships = selectableMemberships(me);
  const mine = new Map(memberships.map((m) => [m.contract.contractId, m]));
  const rows = allContracts
    ? allContracts.map((t) => ({ contractId: t.contractId, name: t.name, role: roleLabel(mine.get(t.contractId)) }))
    : memberships.map((m) => ({ contractId: m.contract.contractId, name: m.contract.name, role: roleLabel(m) }));

  return (
    <>
      <SystemHeader me={me} />
      <main className="narrow">
        {joined && <p className="ok">{joined}に参加しました。</p>}
        <h1>どの契約で利用しますか</h1>
        {rows.length === 0 && <p>所属している契約がありません。管理者に招待を依頼してください。</p>}
        <div>
          {rows.map((r) => (
            <Link key={r.contractId} className="card link" to={`/c/${r.contractId}`}>
              <div className="row"><strong>{r.name}</strong><span className="spacer" /><span className="badge">{r.role}</span></div>
            </Link>
          ))}
        </div>
      </main>
    </>
  );
}

function roleLabel(m: Me["memberships"][number] | undefined): string {
  if (!m) return "システム管理者";
  return m.isAdmin ? "管理者" : "メンバー";
}
